export default __webpack_public_path__ + "static/dxb-28a4483ccbe3e1458c73ba002a03ce82.webp";